<template>
  <div class="card">
    <div class="card-body">
      <h5 class="fw-bold mb-3">Review</h5>
      <div class="mb-3">
        <p class="mb-1"><strong>Inputs:</strong> {{ rawCount }}</p>
        <p class="mb-1"><strong>After dedup:</strong> {{ deduped.length }}</p>
        <p v-if="overCap" class="text-danger mb-0">
          Over the {{ maxBatch }}-UUID cap. Reduce the list before submitting.
        </p>
      </div>

      <pre class="bg-light p-3 small mb-3" style="max-height: 240px; overflow: auto">{{
        deduped.join('\n')
      }}</pre>

      <div class="d-flex justify-content-between">
        <button class="btn btn-outline-secondary" @click="emit('back')">Back</button>
        <button
          class="btn btn-primary"
          :disabled="overCap || submitting"
          @click="emit('submit', deduped)"
        >
          <span v-if="submitting" class="spinner-border spinner-border-sm me-2" />
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ uuids: string[]; submitting: boolean }>();
const emit = defineEmits<{ (e: 'back'): void; (e: 'submit', uuids: string[]): void }>();

const maxBatch = 500;
const rawCount = computed(() => props.uuids.length);
const deduped = computed(() =>
  Array.from(new Set(props.uuids.map((u) => u.trim()).filter(Boolean))),
);
const overCap = computed(() => deduped.value.length > maxBatch);
</script>
